import React from 'react'
import { Link, graphql } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import Layout from '../components/layouts/mainLayout'
import Banner from '../components/banner'

import '../styles/announcements.scss'
import Head from '../components/head'

export const query = graphql`
    query($slug:String!) {
        contentfulAnnouncementsTemplate(slug: {eq: $slug}){
            title
            publishedDate(formatString: "MMMM Do, YYYY")
            body {
                json
            }
            linkToNextPage
        }
    }
`

const Announcements = (props) => {

    const options = {
        renderNode: {
            "embedded-asset-block": (node) => {
                const alt = node.data.target.fields.title['en-US']
                const url = node.data.target.fields.file['en-US'].url
                return <img src={url} alt={alt} />
            }
        }
    }

    return (
        <Layout>
            <Head title={props.data.contentfulAnnouncementsTemplate.title}/>
            <div class="announcement">
                <h1>{props.data.contentfulAnnouncementsTemplate.title}</h1>
                <div className="date">{props.data.contentfulAnnouncementsTemplate.publishedDate}</div>
                {documentToReactComponents(props.data.contentfulAnnouncementsTemplate.body.json, options)}
                <Link className="btn" to={`/announcements/${props.data.contentfulAnnouncementsTemplate.linkToNextPage}`}>Go To Previous Announcement</Link>
            </div> 
        </Layout>
    )
}

export default Announcements
